/*
  BØLG — Sincronizador del ítem "Personalizado" (fee de personalización) en el carrito.

  Contexto: el fee de $1.990 se agrega como una LÍNEA APARTE (producto
  "personalizado", variante 52428728434968) junto a la botella, no como un
  recargo de variante. Al no estar atada a la botella quedaba:
    - HUÉRFANA: si el cliente sacaba la botella, el fee seguía cobrando solo,
      invisible y sin poder eliminarlo (el "$1.990 fantasma" que reportó Diego).
    - DESINCRONIZADA: cambiar la cantidad de la botella en el carrito no
      cambiaba la cantidad del fee.

  Este script mantiene SIEMPRE:  cantidad_marcador == unidades de botellas
  personalizadas en el carrito. Si no hay botellas personalizadas, elimina el
  marcador. Corre al cargar cualquier página, así auto-repara carritos ya rotos.

  Es idempotente y con guardas anti-bucle: si ya está sincronizado no toca nada.
*/
(function () {
  'use strict';

  // Producto "personalizado" (fee $1.990). Debe coincidir con data-marker-variant
  // en snippets/bottle-personalization.liquid.
  var MARKER_VARIANT = 52428728434968;

  var busy = false;      // hay una pasada en curso
  var pending = false;   // llegó otro evento mientras estábamos ocupados

  // Una línea es "botella personalizada" del personalizador NATIVO solo si trae
  // alguna de estas propiedades, que syncCapture SIEMPRE setea al personalizar
  // (ver assets/bottle-personalization.js) y que son exclusivas de nuestro
  // personalizador. NO usamos un match amplio tipo /personaliz/ sobre las keys:
  // una opción de HulkApps/Zepto llamada "Personalización" daría falso positivo
  // y le agregaría el marcador de $1.990 a un producto que no corresponde.
  //
  //   _bolg          marcador actual (desde 28-jul-2026)
  //   _vista_previa  URL del grabado; redundante a propósito, para que el cobro
  //                  no dependa de una sola señal
  //   _spec          LEGADO. Se dejó de escribir el 28-jul-2026 al limpiar el
  //                  pedido, pero los carritos abandonados de antes todavía lo
  //                  traen. Si se saca de acá, esos carritos dejan de cobrar los
  //                  $1.990 al retomarse. Se puede borrar pasados ~90 días.
  function esPersonalizada(item) {
    if (!item || item.variant_id === MARKER_VARIANT) return false;
    var p = item.properties;
    if (!p) return false;
    return !!(p._bolg || p._vista_previa || p._spec);
  }

  function jsonPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  }

  function repintarCarrito() {
    // Que el tema repinte el drawer y/o la página del carrito ya corregidos.
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
  }

  function reconciliar() {
    if (busy) { pending = true; return; }
    busy = true;
    return getCart().then(function (cart) {
      var quiere = 0, tiene = 0, markerKey = null;
      (cart.items || []).forEach(function (it) {
        if (it.variant_id === MARKER_VARIANT) { tiene += it.quantity; markerKey = it.key; }
        else if (esPersonalizada(it)) { quiere += it.quantity; }
      });
      if (quiere === tiene) return null;                    // ya sincronizado -> nada
      if (quiere === 0) return jsonPost('/cart/change.js', { id: markerKey, quantity: 0 });   // huérfano -> eliminar
      if (markerKey) return jsonPost('/cart/change.js', { id: markerKey, quantity: quiere });  // ajustar cantidad
      return jsonPost('/cart/add.js', { items: [{ id: MARKER_VARIANT, quantity: quiere }] });  // faltaba -> agregar
    }).then(function (cambio) {
      if (cambio) repintarCarrito();
    }).catch(function () {
      /* nunca romper la página por esto */
    }).then(function () {
      busy = false;
      if (pending) { pending = false; reconciliar(); }
    });
  }

  var t = null;
  function agendar() { clearTimeout(t); t = setTimeout(reconciliar, 150); }

  // 1) Al cargar cualquier página: auto-repara carritos ya rotos (el fantasma).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', agendar);
  } else {
    agendar();
  }

  // 2) Cada vez que el carrito cambia. OJO: repintarCarrito() dispara 'cart:build'
  //    que en el tema termina disparando 'cart:updated'; la guarda quiere===tiene
  //    hace que la 2ª pasada no toque nada y el ciclo converja en un paso.
  document.addEventListener('cart:updated', agendar);
  document.addEventListener('ajaxProduct:added', agendar);
})();
